import classNames from 'classnames';

import { Button } from './button';
import { ButtonProps } from './button.types';
import { BUTTON_VARIANT_M } from './config';

export const ButtonPrimary = ({ disabled, variant = BUTTON_VARIANT_M, children, className, ...props }: ButtonProps) => {
  return (
    <Button
      disabled={disabled}
      {...props}
      className={classNames(className, {
        'fill-dark focus:fill-dark-active text-negative': !disabled,
        'fill-dark-disabled text-disabled': disabled,
      })}
      borderClasses='border-0'
      variant={variant}>
      {children}
    </Button>
  );
};
